import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  TrendingUp,
  Users,
  Wallet as WalletIcon,
  User,
  LogOut,
} from "lucide-react";

const MobileLayout = ({ children, showBottomNav = true }) => {
  const location = useLocation();

  const bottomNavItems = [
    { path: "/home", icon: Home, label: "Home" },
    { path: "/trading", icon: TrendingUp, label: "Sales" },
    { path: "/network", icon: Users, label: "Network" },      // ✅ changed
    { path: "/funds", icon: WalletIcon, label: "Fund" },  // ✅ changed
    { path: "/profile", icon: User, label: "Profile" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Top Header */}
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-50">
        <div className="flex items-center gap-2">
          <img
            src="/logo.png"
            alt="Tikhat Partner"
            className="h-12 object-contain"
          />
          <span className="text-lg font-semibold text-[#0A4683]">
            Tikhat Partner
          </span>
        </div>

        <button
          onClick={() => {
            if (window.confirm("Logout?")) {
              localStorage.clear();
              window.location.href = "/login";
            }
          }}
          className="p-2 hover:bg-gray-100 rounded-full"
        >
          <LogOut className="w-6 h-6 text-gray-700" />
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto pb-20">
        {children}
      </main>

      {/* Bottom Navigation */}
      {showBottomNav && (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-2 py-2 z-50">
          <div className="flex justify-around items-center max-w-screen-sm mx-auto">
            {bottomNavItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-colors ${
                    active
                      ? "text-primary bg-primary-light"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  <Icon className="w-6 h-6" />
                  <span className="text-xs font-medium">
                    {item.label}
                  </span>
                </Link>
              );
            })}
          </div>
        </nav>
      )}
    </div>
  );
};

export default MobileLayout;
